import { getRequest, postRequest } from "../utils/axios";

const projectQuery = (projectHash) => `?project=${projectHash}`;

export const deploymentsService = {
  list: (projectHash, onSuccess, onError) =>
    getRequest(`/api/v1/deployments/${projectQuery(projectHash)}`, onSuccess, onError),
  rollback: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/deployments/${hash}/rollback/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  redeploy: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/deployments/${hash}/redeploy/${projectQuery(projectHash)}`, {}, onSuccess, onError),
  resolveConflicts: (projectHash, hash, onSuccess, onError) =>
    postRequest(
      `/api/v1/deployments/${hash}/resolve_conflicts/${projectQuery(projectHash)}`,
      {},
      onSuccess,
      onError,
    ),
  cancel: (projectHash, hash, onSuccess, onError) =>
    postRequest(`/api/v1/deployments/${hash}/cancel/${projectQuery(projectHash)}`, {}, onSuccess, onError),
};
